import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faWarning,
  faCheckCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import HtmlToReact from 'html-to-react';
import HtmlToReactInstructions
  from '@avtechsoftware/react-component-library/src/utility/HtmlToReactInstructions';

const htmlToReactParser = new HtmlToReact.Parser();

const ALERT_DISPLAY_SPECS = {
  info: {
    icon: faInfoCircle,
    class: 'alert-info',
  },
  notice: {
    icon: faWarning,
    class: 'alert-warning',
  },
  warning: {
    icon: faWarning,
    class: 'alert-danger',
  },
  success: {
    icon: faCheckCircle,
    class: 'alert-success',
  },
};

const AccountMessageBox = ({
  message,
  showDate = false,
  id,
  onDismiss,
}) => {
  const alertSpec = ALERT_DISPLAY_SPECS[message.type] || ALERT_DISPLAY_SPECS.INFO;

  const handleDismiss = () => {
    if (onDismiss) {
      onDismiss(id);
    }
  };

  const processedMessage = htmlToReactParser.parseWithInstructions(
    message.formattedMessage,
    () => true,
    HtmlToReactInstructions,
  );

  return (
    <div
      id={id}
    >
      <div className={`alert ${alertSpec.class} d-flex align-items-center py-2 px-2`}>
        <div className="d-flex align-items-center mr-auto">
          {showDate && message.timeCreated && (
            <small className="text-muted mr-2">
              {moment.unix(message.timeCreated).format('M j, Y g:i A')}
            </small>
          )}
          <FontAwesomeIcon
            icon={alertSpec.icon}
            className="fa-fw mr-2"
            size="sm"
          />
          <div
            className="flex-grow-1"
          >
            {processedMessage}
          </div>

        </div>
        <Button
          className="btn btn-sm btn-light"
          title="dismiss"
          onClick={handleDismiss}
        >
          Dismiss
        </Button>
      </div>
    </div>
  );
};

AccountMessageBox.propTypes = {
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['info', 'notice', 'warning', 'success']),
    timeCreated: PropTypes.number.isRequired,
    formattedMessage: PropTypes.node.isRequired,
  }).isRequired,
  showDate: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default AccountMessageBox;
